// Icônes & graphismes ORIGINAUX Plan Permis (dessinés à la main, motif "route" du logo).
// Style duotone : traits en `currentColor`, accents en bleu électrique de la marque.
const ACCENT = "#4DA6FF";

// --- 3 solutions ---------------------------------------------------------

// Date d'examen rapide : calendrier + éclair
export const IconFastDate = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="6" width="24" height="22" rx="4" stroke="currentColor" strokeWidth="2" />
    <path d="M4 12h24" stroke="currentColor" strokeWidth="2" />
    <path d="M10 4v4M22 4v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M17 15l-4 6h4l-1.5 5 5.5-7h-4z" fill={ACCENT} stroke={ACCENT} strokeWidth="1.2" strokeLinejoin="round" />
  </svg>
);

// Examen en campagne : route sinueuse entre collines + soleil (reprend le motif route du logo)
export const IconCountryside = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M3 27c4 0 5-6 9-6s5 5 9 5 4-5 8-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="24" cy="8" r="3.5" fill={ACCENT} />
    <path d="M13 28c0-4 1.5-7 3-10s2.5-6 2.5-9" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeDasharray="1 4" />
    <path d="M6 20c1.6 0 2-3.2 3.6-3.2S11.6 20 13 20" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.6" />
  </svg>
);

// Permis accéléré : compteur de vitesse
export const IconAccelerated = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M5 24a12 12 0 1 1 22 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M16 20l7-6" stroke={ACCENT} strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="16" cy="20" r="2.4" fill={ACCENT} />
    <path d="M8 19.5l1.5 .8M24 19.5l-1.5 .8M16 9v1.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" opacity="0.7" />
  </svg>
);

// --- petits pictos "confiance" ------------------------------------------

export const IconShieldFree = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 2.5l7 2.6v5.4c0 4.8-3.1 8.1-7 9.5-3.9-1.4-7-4.7-7-9.5V5.1l7-2.6z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8.5 12l2.4 2.4L15.8 9.6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconStar = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="#FFC107" className={className} aria-hidden="true">
    <path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.2l1-5.8L3.5 9.2l5.9-.9L12 3z" />
  </svg>
);

export const IconClockFast = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="13" r="7.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 9.5V13l2.5 1.6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 3.5h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconRoadCheck = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M6 21l3-16M18 21l-3-16M12 6v2M12 12v2M12 18v1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M4 21h16" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
  </svg>
);


// --- Ambassadeurs : jeu d'icônes sur-mesure (remplace les icônes génériques) ---

// Étape 1 — Code ambassadeur unique : ticket perforé avec accent
export const IconAmbCode = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M5 9h22a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4v-3a2 2 0 0 1 2-2z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M12 9v14" stroke="currentColor" strokeWidth="2" strokeDasharray="2 3" strokeLinecap="round" />
    <path d="M17 13.5h7M17 18.5h5" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Étape 2 — Recommander (bouche-à-oreille) : réseau de personnes
export const IconAmbShare = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <circle cx="9" cy="10" r="3.4" stroke="currentColor" strokeWidth="2" />
    <circle cx="23" cy="8" r="2.8" fill={ACCENT} />
    <circle cx="23" cy="20" r="2.8" stroke="currentColor" strokeWidth="2" />
    <path d="M11.6 12.2l8.9 6M11.9 9.2l8.5-0.6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
    <path d="M4 25c0-3.3 2.4-5.2 5-5.2s5 1.9 5 5.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

// Étape 3 — Le candidat renseigne le code : formulaire + crayon
export const IconAmbForm = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <rect x="6" y="4" width="16" height="24" rx="3" stroke="currentColor" strokeWidth="2" />
    <path d="M10 11h8M10 16h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M24 15.5l3.5 3.5-6.5 6.5-3.6.4.4-3.6 6.2-6.8z" fill="none" stroke={ACCENT} strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

// Étape 4 — Rémunéré à l'inscription : pièces / commission
export const IconAmbCoins = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <ellipse cx="13" cy="9" rx="8" ry="3.4" stroke="currentColor" strokeWidth="2" />
    <path d="M5 9v6c0 1.9 3.6 3.4 8 3.4s8-1.5 8-3.4V9" stroke="currentColor" strokeWidth="2" />
    <circle cx="22" cy="21" r="6" fill="none" stroke={ACCENT} strokeWidth="2" />
    <path d="M22 18v6M20.2 19.6h2.6a1.4 1.4 0 0 1 0 2.8h-1.6a1.4 1.4 0 0 0 0 2.8h2.6" stroke={ACCENT} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Tableau de bord ambassadeur : cadran / stats
export const IconAmbDashboard = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="3" y="4" width="8" height="6" rx="1.6" stroke="currentColor" strokeWidth="1.8" />
    <rect x="3" y="13" width="8" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.8" />
    <rect x="14" y="4" width="7" height="9" rx="1.6" fill={ACCENT} opacity="0.18" stroke={ACCENT} strokeWidth="1.8" />
    <rect x="14" y="16" width="7" height="4" rx="1.6" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

// Sceau de validation (remplace BadgeCheck)
export const IconAmbSeal = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M16 3l3 2.2 3.6-.5 1.4 3.4 3.3 1.6-.6 3.6 2.3 2.8-2.3 2.8.6 3.6-3.3 1.6-1.4 3.4-3.6-.5L16 29l-3-2.2-3.6.5-1.4-3.4L4.7 22.3l.6-3.6L3 15.9l2.3-2.8-.6-3.6 3.3-1.6L9.4 4.7 13 5.2 16 3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M11 16l3.2 3.2L21 12.4" stroke={ACCENT} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Petites utilitaires : copier / valider (remplacent lucide Copy / Check)
export const IconCopy = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="8" y="8" width="12" height="13" rx="2.4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M16 8V5.4A2.4 2.4 0 0 0 13.6 3H6.4A2.4 2.4 0 0 0 4 5.4v11A2.4 2.4 0 0 0 6.4 18.8H8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconCheck = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4.5 12.5l4.5 4.5 10.5-11" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// --- Jeu utilitaire de marque (remplace les icônes génériques des tableaux de bord) ---

export const IconUsers = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3.5 20c0-3.1 2.5-5 5.5-5s5.5 1.9 5.5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M16 6.2a3 3 0 0 1 0 5.6M17.5 20c0-2.4-1-4-2.6-4.7" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconUserCheck = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3.5 20c0-3.1 2.5-5 5.5-5 1.1 0 2.1.25 3 .7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M15 18l1.8 1.8L21 15.6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconTrend = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 15l5-5 3.5 3.5L20 6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 6h5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 20h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconTimes = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 9l6 6M15 9l-6 6" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconChat = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H9l-4 3.5V6.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8.5 9.5h7M8.5 12.5h4" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconPhone = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M6.5 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4.5 6.2 2 2 0 0 1 6.5 4z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
  </svg>
);

export const IconMail = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="3.5" y="5.5" width="17" height="13" rx="2.4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M4.5 7l7.5 5.5L19.5 7" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconPin = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 21c4.5-4.2 7-7.5 7-11a7 7 0 1 0-14 0c0 3.5 2.5 6.8 7 11z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <circle cx="12" cy="10" r="2.6" fill={ACCENT} />
  </svg>
);

export const IconWallet = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="3.5" y="6" width="17" height="13" rx="2.6" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3.5 9.5h12A2.5 2.5 0 0 1 18 12v0a2.5 2.5 0 0 1-2.5 2.5h-2" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="16" cy="12" r="1.2" fill={ACCENT} />
  </svg>
);


// --- Bibliothèque back-office (remplace lucide dans /pro et /qualif) ---

export const IconUser = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="8" r="3.4" stroke="currentColor" strokeWidth="1.8" />
    <path d="M5 20c0-3.4 3-5.5 7-5.5s7 2.1 7 5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconCar = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 15l1.4-4.2A3 3 0 0 1 8.2 8.6h7.6a3 3 0 0 1 2.8 2.2L20 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="3.5" y="15" width="17" height="4.5" rx="1.6" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="7.5" cy="19.5" r="1.4" fill={ACCENT} />
    <circle cx="16.5" cy="19.5" r="1.4" fill={ACCENT} />
  </svg>
);

export const IconFlag = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M6 21V4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M6 5h11l-2 3 2 3H6z" fill={ACCENT} stroke={ACCENT} strokeWidth="1.4" strokeLinejoin="round" />
  </svg>
);

export const IconSend = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M20 4L3.5 11l6.5 2.2M20 4l-5 16-4.9-6.8M20 4l-9.9 9.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.1 13.2L20 4" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconX = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconNote = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M5 4.5h14v10L14 20H5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M14 20v-5h5" stroke={ACCENT} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8 9h8M8 12.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconRefresh = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4.5 12a7.5 7.5 0 0 1 12.9-5.2L20 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.5 12a7.5 7.5 0 0 1-12.9 5.2L4 15" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 5v4h-4M4 19v-4h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconBuilding = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="5" y="3.5" width="14" height="17" rx="1.6" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 7.5h2M13 7.5h2M9 11h2M13 11h2M9 14.5h2M13 14.5h2" stroke={ACCENT} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M10 20.5v-3h4v3" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const IconAlert = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 4l8.5 15H3.5L12 4z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M12 10v4" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="16.5" r="1.1" fill={ACCENT} />
  </svg>
);

export const IconCalendar = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="5.5" width="16" height="14" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M4 9.5h16" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3.5v3M16 3.5v3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="9" cy="13.5" r="1.1" fill={ACCENT} />
    <circle cx="13" cy="13.5" r="1.1" fill={ACCENT} />
  </svg>
);

export const IconPhoneOff = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M7.5 4.5h2L11 8.5 9 10a11 11 0 0 0 3 3.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 15.5l1-1.3 4 1.5v3a2 2 0 0 1-2.2 2 15.7 15.7 0 0 1-6.6-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 4l16 16" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconCheckCircle = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8.2 12.2l2.6 2.6 5-5.2" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconHand = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M8 11V5.5a1.5 1.5 0 0 1 3 0V10m0 0V4.5a1.5 1.5 0 0 1 3 0V10m0 0V6a1.5 1.5 0 0 1 3 0v6.5c0 3.6-2.5 6.5-6 6.5-2.1 0-3.6-.9-4.8-2.6L4 14.5a1.6 1.6 0 0 1 2.4-2L8 14" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconArrowRightCircle = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 12h6m0 0l-2.5-2.5M15 12l-2.5 2.5" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconClipboard = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="5" y="4.5" width="14" height="16" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M9 4.5a3 3 0 0 1 6 0" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8.5 13l2.3 2.3 4.2-4.4" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconBan = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6.2 6.2l11.6 11.6" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconRoute = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="6.5" cy="18" r="2.2" stroke="currentColor" strokeWidth="1.8" />
    <circle cx="17.5" cy="6" r="2.2" stroke={ACCENT} strokeWidth="1.8" />
    <path d="M8.7 18h5.3a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h5.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0.1 3.4" />
  </svg>
);

export const IconPlus = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconPencil = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M15 5.5l3.5 3.5-10 10L5 20l1-3.5 9-11z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M14 6.5l3.5 3.5" stroke={ACCENT} strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconTrash = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M5 7h14M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.5 7l1 12.5A1.5 1.5 0 0 0 9 21h6a1.5 1.5 0 0 0 1.5-1.5L17.5 7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M10 11v6M14 11v6" stroke={ACCENT} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconInfo = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 11v5" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
    <circle cx="12" cy="8" r="1.1" fill={ACCENT} />
  </svg>
);

export const IconFile = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M6 3.5h7l5 5V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V3.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M13 3.5V9h5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M9 13h6M9 16h4" stroke={ACCENT} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

export const IconLoader = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M12 3.5v4M12 16.5v4M3.5 12h4M16.5 12h4M6 6l2.8 2.8M15.2 15.2L18 18M18 6l-2.8 2.8M8.8 15.2L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export const IconSearch = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="11" cy="11" r="6.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M15.5 15.5L20 20" stroke={ACCENT} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const IconTicket = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M13 6v12" stroke={ACCENT} strokeWidth="1.6" strokeDasharray="1.5 2.5" strokeLinecap="round" />
  </svg>
);

